import { formatUnits, parseUnits } from 'viem'
import web3 from 'web3'

import { DECIMALS_WEI_USDC } from 'constants/number'

export const convertTokenToWei = (value: any, decimal: any) => {
  if (decimal === 18) return web3.utils.toWei(value.toString(), 'ether')
  else if (decimal === 6) return web3.utils.toWei(value.toString(), 'picoether')
  else if (decimal === 9) return web3.utils.toWei(value.toString(), 'nanoether')
  else if (decimal === 12) return web3.utils.toWei(value.toString(), 'microether')
  else return value.toString() / 10 ** decimal
}

export const convertWeiToToken = (value: any, decimal: any) => {
  if (decimal === 18) return web3.utils.fromWei(value, 'ether')
  else if (decimal === 6) return web3.utils.fromWei(value, 'picoether')
  else if (decimal === 9) return web3.utils.fromWei(value, 'nanoether')
  else if (decimal === 12) return web3.utils.fromWei(value, 'microether')
  else return value / 10 ** decimal
}

export const convertUnitsContract = (
  input: bigint | number | any,
  decimals: number = DECIMALS_WEI_USDC
) => {
  if (!input) return 0
  return Number(formatUnits(input, decimals))
}

export const convertPercentContract = (input: bigint | number | any) => {
  return input ? Number(input) / 100 : 0
}

export const formatAddress = (address: any, head = 8, tail?: number) => {
  if (!address) return ''
  const suffix = tail ?? head
  if (!head && !suffix) return address
  return `${address.slice(0, head)}...${address.slice(-suffix)}`
}

export const parserUnitContract = (
  input: bigint | number | any,
  decimals: number = DECIMALS_WEI_USDC
): bigint => {
  if (!input) return 0n
  return parseUnits(input.toString(), decimals)
}

export const parserPercentContract = (input: number | any) => {
  return input ? Number(input) * 100 : 0
}
